// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var IVCalculationPrice;
(function (IVCalculationPrice) {
    IVCalculationPrice[IVCalculationPrice["Ask"] = 0] = "Ask";
    IVCalculationPrice[IVCalculationPrice["Bid"] = 1] = "Bid";
    IVCalculationPrice[IVCalculationPrice["Last"] = 2] = "Last";
})(IVCalculationPrice || (IVCalculationPrice = {}));
export function getIVCalculationPriceKey(value) {
    switch (value) {
        case IVCalculationPrice.Ask:
            return 'property.Ask';
        case IVCalculationPrice.Bid:
            return 'property.Bid';
        case IVCalculationPrice.Last:
            return 'property.Last';
        default:
            return '';
    }
}
